import { logger } from '../../common/logger';

export const getLocalStorageValue = <T>(key: string) => {
  const storedItem = window.localStorage.getItem(key);

  if (storedItem !== null) {
    try {
      return JSON.parse(storedItem) as T;
    } catch (e) {
      logger.error(
        { error: e },
        `Failed retreiving localStorage item with key: ${key}`
      );
    }
  }
};

export const setLocalStorageValue = <T>(key: string, value: T) => {
  try {
    window.localStorage.setItem(key, JSON.stringify(value));
  } catch (e) {
    logger.error(
      { error: e },
      `Failed to update localStorage with key: ${key}`
    );
  }
};
